import api from "../api";
const login = async (phone,password) => {

  const requestData={
    "phone": phone,
    "password": password,
  }
  try {
    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/user/login", requestData);

    return response.data;

  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }


}

export default login;
